/**
 * TMR API Authorization
 *
 * @type {ngService}
 */
export class TmrApiAuth {
  static ngType = 'service'

  constructor(
    $rootScope,
    $state,
    TmrApi,
    TmrLocalStorage,
    UserStorage,
    TmrInvalidCredentialsError
  ) {
    'ngInject'
    Object.assign(this, {
      $rootScope,
      $state,
      TmrApi,
      TmrLocalStorage,
      UserStorage,
      TmrInvalidCredentialsError,
    })
  }

  login({ username, password }) {
    return this.TmrApi.post('login', null, { username, password }).then(
      res => this.updateLoggedUser(res.data.value),
      err => this.loginError(err)
    )
  }

  loginAs({ username, password, as }) {
    return this.TmrApi.post('loginAs', null, { username, password, as }).then(
      res => this.updateLoggedUser(res.data.value),
      err => this.loginError(err)
    )
  }

  loginError(err) {
    throw err.status === 401 ? new this.TmrInvalidCredentialsError() : err
  }

  logout() {
    // We don't care about logout errors.
    return this.TmrApi.post('logout')
      .catch(() => {})
      .then(() => this.logoutSuccess())
  }

  logoutSuccess() {
    this.TmrLocalStorage.clear('authToken')
    this.$rootScope.$emit('logout')
    return this.$state.reload('app')
  }

  changePassword({ oldPassword, newPassword }) {
    return this.TmrApi.post('changePassword', null, {
      oldPassword,
      newPassword,
    }).then(res => this.updateLoggedUser(res.data.value))
  }

  checkPassword({ value }) {
    return this.TmrApi.post('checkPassword', null, { value }).then(
      res => res.data.value
    )
  }

  resetPassword(username) {
    return this.TmrApi.post('resetPassword', null, null, {
      params: { username },
    })
  }

  resetPasswordAdmin(userId) {
    return this.TmrApi.post('resetPasswordAdmin', null, null, {
      params: { 'user.id': userId },
    }).then(res => res.data.value)
  }

  temporaryLogin(loginToken) {
    return this.TmrApi.post('temporaryLogin', null, {
      value: loginToken,
    }).then(res => this.temporaryLoginSuccess(res.data.value))
  }

  temporaryLoginSuccess(authToken) {
    return this.updateLoggedUser(authToken)
  }

  updateLoggedUser(token, destination = 'app', destinationParams = null) {
    // Set auth token.
    if (token) this.TmrLocalStorage.set('authToken', token)
    // Clear current user.
    this.UserStorage.clearUser()
    // Get user so full user data is automatically loaded.
    let newUser
    return (
      this.UserStorage.getUser()
        // Store new user.
        .then(user => (newUser = user))
        // Give a chance to act before state change
        .then(() => this.$rootScope.$emit('beforeloggeduserupdate', newUser))
        // Reload app.
        .then(() =>
          this.$state.go(destination, destinationParams, {
            reload: true,
            inherit: false,
          })
        )
        // Tell everyone about the good news.
        .then(() => this.$rootScope.$emit('loggeduserupdate', newUser))
    )
  }
}
